import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { showFulfilmentInfo } from "../../../../state/modules/savedItems/actions";
import FulfilmentInformationIcon from "../../../presentational/common/FulfilmentInformationIcon";

const ConnectedFulfilmentInformationIcon = props => {
  const dispatch = useDispatch();

  return (
    <FulfilmentInformationIcon
      {...props}
      showFulfilmentInfo={payload => dispatch(showFulfilmentInfo(payload))}
    />
  );
};

ConnectedFulfilmentInformationIcon.propTypes = {
  productId: PropTypes.number.isRequired,
  variantId: PropTypes.number,
  seller: PropTypes.shape({
    id: PropTypes.string.isRequired
  }),
  source: PropTypes.shape({
    id: PropTypes.string.isRequired
  })
};

export default ConnectedFulfilmentInformationIcon;
